/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DLinkWithIcon from '../link-with-icon/link-with-icon';
import styles from './quote.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Quote link with item
 *
 * @element c4d-quote-link-with-icon
 */
@customElement(`${c4dPrefix}-quote-link-with-icon`)
class C4DQuoteLinkWithIcon extends C4DLinkWithIcon {
  static get stableSelector() {
    return `${c4dPrefix}--quote-link-with-icon`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DQuoteLinkWithIcon;
